import { useState, useEffect } from "react"
import { Link, useNavigate } from "react-router-dom"
import { useAuth } from "../contexts/AuthContext"
import ThemeToggle from "../components/ThemeToggle"
import Footer from "../components/Footer"

const Login = () => {
  const [formData, setFormData] = useState({ email: "", password: "" })
  const [rememberMe, setRememberMe] = useState(false)
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState("")
  const [showServerConfig, setShowServerConfig] = useState(false)
  const [customServerUrl, setCustomServerUrl] = useState(localStorage.getItem("api_base_url") || "")
  const { login } = useAuth()
  const navigate = useNavigate()

  const handleSaveServer = () => {
    if (customServerUrl) {
      localStorage.setItem("api_base_url", customServerUrl);
      alert("Server URL updated. The app will reload to apply changes.");
      window.location.reload();
    } else {
      localStorage.removeItem("api_base_url");
      window.location.reload();
    }
  };

  // Real-time validation state
  const [isValidEmail, setIsValidEmail] = useState(null) // null, true, false
  const [isValidPassword, setIsValidPassword] = useState(null)

  useEffect(() => {
    if (formData.email) {
      setIsValidEmail(formData.email.includes('@') && formData.email.includes('.'))
    } else {
      setIsValidEmail(null)
    }
    
    if (formData.password) {
      setIsValidPassword(formData.password.length > 0)
    } else {
      setIsValidPassword(null)
    }
  }, [formData])

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    setMessage("")

    const result = await login(formData.email, formData.password, rememberMe)

    if (result.success) {
      navigate("/dashboard")
    } else {
      setMessage(result.message)
    } 

    setLoading(false)
  }

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  return (
    <div className="auth-wrapper">
      <div className="theme-toggle-wrapper">
          <ThemeToggle />
      </div>
      <div className="auth-card">
        {/* AMS Text Logo */}
        <div className="logo-text">AMS</div>

        <h2 className="auth-title">Login</h2>

        {message && (
          <div className={`alert ${message.includes("success") ? "alert-success" : "alert-error"}`}>{message}</div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Email</label>
            <input
              type="email"
              name="email"
              className={`form-input ${isValidEmail === true ? 'input-valid' : isValidEmail === false ? 'input-invalid' : ''}`}
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label className="form-label">Password</label>
            <input
              type="password"
              name="password"
              className={`form-input ${isValidPassword === true ? 'input-valid' : isValidPassword === false ? 'input-invalid' : ''}`}
              value={formData.password}
              onChange={handleChange}
              required
            />
          </div>
          
          <div className="flex-between mb-4">
              <label className="remember-me-label" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                  <input 
                    type="checkbox" 
                    checked={rememberMe} 
                    onChange={(e) => setRememberMe(e.target.checked)} 
                  />
                  <span>Remember me</span>
              </label>
              
              <Link to="/reset-password" style={{ color: "var(--primary)", textDecoration: "none", fontSize: "0.9rem" }}>
                  Forgot Password?
              </Link>
          </div>

          <button type="submit" className="btn btn-primary w-full" disabled={loading}>
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>

        <div className="auth-link">
          <p>
            Don't have an account? <Link to="/role-selection">Register here</Link>
          </p>
          <hr style={{ margin: '1.5rem 0', opacity: 0.1 }} />
          <button 
            type="button" 
            onClick={() => setShowServerConfig(!showServerConfig)}
            style={{ 
              background: 'none', 
              border: 'none', 
              color: 'var(--text-muted)', 
              fontSize: '0.8rem', 
              cursor: 'pointer',
              textDecoration: 'underline'
            }}
          >
            {showServerConfig ? 'Hide Server Settings' : 'Server Settings'}
          </button>
        </div>

        {showServerConfig && (
          <div className="server-config-section" style={{ marginTop: '1rem', padding: '1rem', background: 'rgba(0,0,0,0.05)', borderRadius: '8px' }}>
            <label className="form-label" style={{ fontSize: '0.8rem' }}>Backend Server URL</label>
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <input
                type="text"
                className="form-input"
                style={{ fontSize: '0.8rem', padding: '0.4rem' }}
                placeholder="https://your-api.com"
                value={customServerUrl}
                onChange={(e) => setCustomServerUrl(e.target.value)}
              />
              <button 
                type="button" 
                className="btn btn-primary" 
                style={{ padding: '0.4rem 0.8rem', fontSize: '0.8rem' }}
                onClick={handleSaveServer}
              >
                Save
              </button>
            </div>
            <p style={{ fontSize: '0.7rem', marginTop: '0.5rem', color: 'var(--text-muted)' }}>
              Current: {localStorage.getItem('api_base_url') || 'Default'}
            </p>
          </div>
        )}
      </div>
      
      {/* Footer for Login Page */}
      <div className="auth-footer-wrapper">
         <Footer />
      </div>
    </div>
  )
}

export default Login
